import React from 'react';
import { T } from 'react-translator-component';
import './KioskEventProcessingOverlay.css';

/**
 * KioskEventProcessingOverlay
 * Componente que muestra un overlay mientras se procesa un evento de Kiosk.
 * Se superpone sobre cualquier pantalla que esté actualmente visible.
 */
const KioskEventProcessingOverlay = () => {
  return (
    <div className="kiosk-event-processing-overlay">
      <div className="kiosk-event-processing-container">
        <div className="kiosk-event-processing-spinner"></div>
        <h2 className="kiosk-event-processing-title">{T('kiosk.receiving-info')}</h2>
      </div>
    </div>
  );
};

export default KioskEventProcessingOverlay;

